<template>
  <div>
    <data-entry-new-main></data-entry-new-main>
  </div>
</template>

<script>
import DataEntryNewMain from "@/components/ecologist/dataEntryNew/dataEntryNewMain";
export default {
  name: "dataEntryNewMainView",
  components: { DataEntryNewMain },
};
</script>

<style scoped></style>
